import { useEffect, useState, useCallback } from 'react';
import './head404.scss';
import { useStaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { BLOCKS } from '@contentful/rich-text-types';

const Head404 = () => {
    const data = useStaticQuery(graphql`
        query GET_404 {
            allContentfulTemplate(filter: { titulo: { eq: "404" } }) {
                nodes {
                    titulo
                    tituloEnriquecido {
                        raw
                    }
                    imagen {
                        file {
                            url
                        }
                    }
                }
            }
        }
    `);
    const [timer, setTimer] = useState(5);
    const [finishTimer, setFinishTimer] = useState(false);
    const { isBrowser, localStorage } = useBrowserMode();
    const referencia404 = data.allContentfulTemplate.nodes[0];

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
                <p>{children}</p>
            ),
            [BLOCKS.HEADING_1]: (_node: any, children: any) => (
                <h1>{children}</h1>
            ),
        },
    };

    const reloadPage = () => {
        const actualPage: any = localStorage.getItem('CURRENT_TAB')?.toString();
        const hostname = window?.location.hostname;

        if (actualPage === 'empresas') {
            hostname === 'localhost'
                ? (window.location.href = '/empresas')
                : (window.location.href = '/portal-servicios/empresas');
        } else {
            hostname === 'localhost'
                ? (window.location.href = '/personas')
                : (window.location.href = '/portal-servicios/personas');
        }
    };

    const convertTimeInterval = useCallback(() => {
        return setInterval(() => {
            if (timer > 0) {
                setTimer(timer - 1);
                return;
            }
            setFinishTimer(true);
        }, 1000);
    }, [timer]);

    useEffect(() => {
        const interval = convertTimeInterval();

        if (timer === 0) {
            setFinishTimer(true);
            clearInterval(interval);
            reloadPage();
        }

        return () => {
            clearInterval(interval);
        };
    }, [finishTimer, timer]);

    return (
        <>
            {isBrowser && (
                <section className="o-head404">
                    <article className="o-head404__container">
                        {referencia404.tituloEnriquecido &&
                            documentToReactComponents(
                                JSON.parse(referencia404.tituloEnriquecido.raw),
                                options
                            )}
                        <p>
                            Seras Redirigido a la pagina inicial en: {timer}{' '}
                            Segundos
                        </p>
                    </article>
                    <figure className="o-head404__cover">
                        <img
                            loading="lazy"
                            className="o-head404__cover__img"
                            src={
                                referencia404.imagen[0] &&
                                referencia404.imagen[0].file.url
                            }
                            alt={referencia404.imagen[0].title}
                        />
                    </figure>
                </section>
            )}
        </>
    );
};

export default Head404;
